import { Fragment, useState } from "react";

import CustomSelectDropdown from "../../../CustomHTMLElements/CustomSelectDropdown";
import { formatMoney } from "../../../../helpers/formatter";
import { ReactComponent as NairaIcon } from "../../../../assets/svg/icons/naira.svg";
import { ReactComponent as DollarIcon } from "../../../../assets/svg/icons/dollar.svg";
import { ReactComponent as KenyaIcon } from "../../../../assets/svg/icons/KSH.svg";
import Loader from "../../../../NewComponents/Loader/Loader.component";

import useCoreBankingTenantInfo from "../../../../custom-hooks/useCoreBankingTenant";
import useMifosProduct from "../../../../custom-hooks/useMifosProduct";

import styles from "./../../Investment.module.scss";

export default function Financials({
  handleChange,
  state,
  setState,
  selectedProductDetails,
}) {
  const [checkStatus, setCheckStatus] = useState("off");
  const [selectedCoreBankingTenant, setSelectedCoreBankingTenant] =
    useState("");

  const {
    data: coreBankingTenant,
    isError: isCoreBankingTenantError,
    error: coreBankingTenantError,
  } = useCoreBankingTenantInfo();
  const {
    data: mifosProduct,
    isError: isMifosProductError,
    error: mifosProductError,
    isLoading: isMifosProductLoding,
  } = useMifosProduct({
    productType: 3,
    tenantId: selectedCoreBankingTenant,
  });

  const getAppropriateCurrencyIcon = (currencyInQuestion) => {
    switch (currencyInQuestion) {
      case "NGN":
        return {
          icon: <NairaIcon />,
          symbol: "\u20A6",
        };
      case "USD":
        return {
          icon: <DollarIcon />,
          symbol: "\u0024",
        };
      case "KES":
        return {
          icon: <KenyaIcon />,
          symbol: "KES",
        };

      default:
        break;
    }
  };

  const checkInvestmentCap = (e) => {
    e.preventDefault();
    if (checkStatus === "on") {
      setCheckStatus("off");
    } else {
      setCheckStatus("on");
    }
  };

  const handleChangeTenant = (e) => {
    if (!e.target.value) {
      setSelectedCoreBankingTenant("");
    } else {
      setSelectedCoreBankingTenant(e.target.value);
    }
  };

  const handleSearchBy = (e) => {
    const eachData = mifosProduct.find(
      (data) => data.id === Number(e.target.value)
    );

    const { minimum_investment, maximum_investment, currency_code } = eachData;

    const currenState = { ...state };

    const result = currenState.investment_product_details.find(
      (item) => item.value === selectedProductDetails.value
    );

    const indexOfResult = currenState?.investment_product_details.findIndex(
      (item) => item === result
    );

    const newProductDetailsArray = currenState?.investment_product_details;
    newProductDetailsArray[indexOfResult] = {
      ...newProductDetailsArray[indexOfResult],
      currency_code: currency_code,
      core_banking_product_id: e.target.value,
      core_banking_tenant_id: selectedCoreBankingTenant,
      minimum_investment: minimum_investment,
      maximum_investment: maximum_investment,
    };

    setState((prev) => ({
      ...prev,
      investment_product_details: newProductDetailsArray,
    }));
  };

  const handleChangeInvestmentSize = (e) => {
    const currenState = { ...state };

    const result = currenState.investment_product_details.find(
      (item) => item.value === selectedProductDetails.value
    );

    const indexOfResult = currenState?.investment_product_details.findIndex(
      (item) => item === result
    );

    const newProductDetailsArray = currenState?.investment_product_details;
    newProductDetailsArray[indexOfResult] = {
      ...newProductDetailsArray[indexOfResult],
      investment_size: e.target.value,
    };

    setState((prev) => ({
      ...prev,
      investment_product_details: newProductDetailsArray,
    }));
  };
  return (
    <Fragment>
      <div className="page-subtitle col-md-12 mt-3">
        <h3
          className="mb-3"
          style={{
            backgroundColor: "#F4F5F6",
            fontSize: "16px",
            padding: "10px",
          }}
        >
          {selectedProductDetails?.label}
        </h3>
      </div>
      <div className="col-md-12">
        <CustomSelectDropdown
          onChange={handleChangeTenant}
          name="core_banking_tenant_id"
          defaultValue={selectedProductDetails.core_banking_tenant_id}
          label="Core Banking Tenant"
          className="round user__form form-control mb-3"
        >
          <option value=""> Select Core Banking Tenant</option>
          {coreBankingTenant &&
            coreBankingTenant?.data.map((data) => {
              const { full_name, id, tenant_id } = data;
              return (
                <option value={tenant_id} key={id}>
                  {full_name}
                </option>
              );
            })}
        </CustomSelectDropdown>
      </div>
      {selectedCoreBankingTenant && (
        <div className="col-md-12">
          {isMifosProductLoding ? (
            <Loader />
          ) : (
            <CustomSelectDropdown
              onChange={(e) => {
                handleSearchBy(e);
              }}
              name="core_banking_product_id"
              defaultValue={selectedProductDetails.core_banking_product_id}
              label="Mifos Product"
              className="round user__form form-control mb-3"
            >
              <option value=""> Select a mifos product</option>
              {mifosProduct &&
                mifosProduct.map((data) => {
                  const { id, name } = data;
                  return (
                    <option value={id} key={id}>
                      {name}
                    </option>
                  );
                })}
            </CustomSelectDropdown>
          )}
        </div>
      )}

      <div className="col-md-6">
        <label>
          Minimum Investment{" "}
          {formatMoney(
            selectedProductDetails.minimum_investment,
            getAppropriateCurrencyIcon(selectedProductDetails?.value)?.symbol
          )}
        </label>
        <div className={styles.inputIcons}>
          <div className={`${styles.icon}`}>
            {getAppropriateCurrencyIcon(selectedProductDetails?.value)?.icon}
          </div>
          <input
            type="number"
            name="minimum_investment"
            value={selectedProductDetails.minimum_investment}
            disabled
            onChange={(e) => handleChange(e)}
            className={`${styles.inputField}`}
          />
        </div>
      </div>
      <div className="col-md-6">
        <label>
          Maximum Investment{" "}
          {formatMoney(
            selectedProductDetails.maximum_investment,
            getAppropriateCurrencyIcon(selectedProductDetails?.value)?.symbol
          )}
        </label>
        <div className={styles.inputIcons}>
          <div className={`${styles.icon}`}>
            {getAppropriateCurrencyIcon(selectedProductDetails?.value)?.icon}
          </div>
          <input
            type="number"
            name="maximum_investment"
            value={selectedProductDetails.maximum_investment}
            disabled
            onChange={(e) => handleChange(e)}
            className={`${styles.inputField}`}
          />
        </div>
      </div>
      <div className="col-md-12 mb-3 mt-3">
        <div className="rounded-border d-flex ">
          <span>Turn on automatic investment cap:</span>
          <div onClick={(e) => checkInvestmentCap(e)}>
            <i
              className={`investment-adv-icon  fas fa-toggle-${checkStatus} fa-lg ml-2`}
            />
          </div>
        </div>
      </div>
      {checkStatus === "on" && (
        <div className="col-md-12 mb-3">
          <label className="label-txt">
            Investment Size{" "}
            {formatMoney(
              selectedProductDetails.investment_size,
              getAppropriateCurrencyIcon(selectedProductDetails?.value)?.symbol
            )}
          </label>
          <input
            type="number"
            className="form-control"
            value={selectedProductDetails.investment_size}
            name="investment_size"
            onChange={(e) => handleChangeInvestmentSize(e)}
          />
        </div>
      )}
    </Fragment>
  );
}
